module.exports = __webpack_public_path__ + "img/img-default-pos.1864c954.jpg";